import { datadogRum } from '@datadog/browser-rum';
import { ErrorSuppressor } from '@infl-ts/util-embed-mode-provider';
import { RA$ } from '@infl-ts/util-fp-ts';
import { Box, Button, ButtonGroup, Link, Typography } from '@mui/material';
import { constNull, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Error = function Error(_ref) {
  var errorCodes = _ref.errorCodes,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? "We couldn't load this page because of an error on our end." : _ref$errorMessage,
      errorToLog = _ref.errorToLog,
      _ref$showReloadPage = _ref.showReloadPage,
      showReloadPage = _ref$showReloadPage === void 0 ? false : _ref$showReloadPage,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100vh' : _ref$height,
      _ref$headerSize = _ref.headerSize,
      headerSize = _ref$headerSize === void 0 ? 'h1' : _ref$headerSize;
  useEffect(function () {
    if (errorToLog) {
      console.error(errorToLog);
      datadogRum.addError(errorToLog);
    }
  }, [errorToLog]);
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "Error",
    "data-source-file": "index.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(ErrorSuppressor, {
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            width: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: height,
            justifyContent: 'center'
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            sx: {
              textAlign: 'center',
              mb: headerSize === 'h1' ? 1.5 : 1
            },
            variant: headerSize,
            children: t('Oh no, something went wrong!')
          }), /*#__PURE__*/_jsx(Typography, {
            sx: {
              textAlign: 'center'
            },
            children: t(errorMessage)
          }), /*#__PURE__*/_jsxs(ButtonGroup, {
            sx: {
              display: 'flex',
              gap: 1,
              mt: 3
            },
            children: [showReloadPage ? /*#__PURE__*/_jsx(Button, {
              sx: {
                minWidth: 156,
                width: 'auto'
              },
              variant: "contained",
              onClick: function onClick() {
                return location.reload();
              },
              children: t('Reload page')
            }) : null, /*#__PURE__*/_jsx(Button, {
              sx: {
                minWidth: 156,
                width: 'auto'
              },
              variant: "contained",
              component: Link,
              href: "/",
              children: t('Go home')
            })]
          }), /*#__PURE__*/_jsx(Button, {
            size: "small",
            sx: {
              mt: 2
            },
            component: Link,
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://influitive-supportdesk.zendesk.com/hc",
            children: t('Contact support')
          }), /*#__PURE__*/_jsx(Typography, {
            sx: {
              mt: 2,
              color: function color(t) {
                return t.palette.text.disabled;
              }
            },
            variant: "caption",
            children: pipe(errorCodes, O.fromPredicate(function (e) {
              return RA$.isArray(e);
            }), O.map(function (errors) {
              return errors.length > 1 ? /*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: 'flex',
                  flexDirection: 'column'
                },
                children: [/*#__PURE__*/_jsx(Box, {
                  sx: {
                    fontWeight: function fontWeight(t) {
                      return t.typography.fontWeightBold;
                    },
                    mb: 0.5
                  },
                  children: t('Error reference numbers:')
                }), errors.map(function (code) {
                  return /*#__PURE__*/_jsx(Box, {
                    children: "".concat(code)
                  }, code);
                })]
              }) : "".concat(t('Error reference number:'), " ").concat(errors[0]);
            }), O.getOrElseW(constNull))
          })]
        })
      });
    }
  });
};